import { render } from "./outboundRecord.vue?vue&type=template&id=af84ad84&scoped=true"
import script from "./outboundRecord.vue?vue&type=script&lang=js"
export * from "./outboundRecord.vue?vue&type=script&lang=js"

import "./outboundRecord.vue?vue&type=style&index=0&id=af84ad84&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-af84ad84"

export default script